import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { authService } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';
import { SILENT_ERROR } from '../lib/queryMeta';

/**
 * Kesh kaliti — foydalanuvchi va maktab id'si bilan. Saqlangandan keyin AYNAN shu
 * kalit yangilanadi (prefiks bo'yicha emas: aks holda shu brauzerda avval kirgan
 * boshqa maktab foydalanuvchisining kesh yozuvi ham ustidan yozilardi).
 */
export const supportEmailQueryKey = (user?: { id?: string; tenantId?: string | null } | null) =>
  ['tenant-support-email', user?.tenantId ?? null, user?.id ?? null] as const;

/** Maktab support email'i uchun chegaralar (backend `routes/tenant.ts` bilan bir xil). */
export const SUPPORT_EMAIL_MAX = 254;
export const SUPPORT_EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

/** Server javobini tekshiradi: faqat haqiqiy email satri o'tadi, qolgani — `null`. */
const sanitize = (v: unknown): string | null =>
  typeof v === 'string' && v.length <= SUPPORT_EMAIL_MAX && SUPPORT_EMAIL_RE.test(v) ? v : null;

/**
 * JORIY sessiya maktabining support email'i (`GET /tenant/support-email`).
 *
 * ZAXIRA — hech qachon boshqa maktabniki yoki platformaning umumiy manzili emas:
 *  • token yo'q (login'dan oldin ochilgan ochiq huquqiy sahifa) → so'rov YUBORILMAYDI;
 *  • 404 (prod backend hali eski), 403, tarmoq xatosi yoki `null` → `data` bo'sh,
 *    chaqiruvchi kontakt qatorini neytral matn bilan chizadi.
 *
 * KESH IZOLYATSIYASI: logout query keshini tozalamaydi, shuning uchun kalitda
 * foydalanuvchi va maktab id'si bor — boshqa hisob bilan kirilganda oldingi
 * maktabning email'i keshdan chiqib qolmaydi.
 *
 * `meta: SILENT_ERROR` + `retry: false`: eski backend'da 404 kutilgan holat —
 * global qizil toast chiqmasin va behuda qayta urinilmasin. 401 da esa (token
 * eskirgan) `services/api.ts` interceptor'i odatdagidek sessiyani tozalaydi —
 * xuddi shu sahifada `AuthContext` ning `/auth/me` so'rovi ham shunday qiladi.
 */
export function useSupportEmail(enabled = true) {
  const { user, isAuthenticated } = useAuth();
  const hasSession = isAuthenticated && !!authService.getToken();
  return useQuery({
    queryKey: supportEmailQueryKey(user),
    queryFn: async () =>
      sanitize((await api.get<{ supportEmail?: unknown }>('/tenant/support-email')).data?.supportEmail),
    enabled: enabled && hasSession,
    meta: SILENT_ERROR,
    retry: false,
  });
}
